var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"audio-player"},[_c('figcaption',[(_vm.title)?_c('h3',{staticClass:"t-heading-sm",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e()]),_vm._v(" "),_c('audio',{attrs:{"src":_vm.file,"controls":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }